import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome, FiArrowLeft, FiSearch, FiShoppingBag } from 'react-icons/fi';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO
        title="404 - Page Not Found | BaileBelle"
        description="The page you're looking for doesn't exist. Explore our collection of premium ballerina dresses and jewelry at BaileBelle."
        keywords="404, page not found, ballerina dresses, ballet jewelry, dance wear"
        noindex={true}
      />
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-pink-500 mb-4">404</h1>
          <h2 className="text-3xl font-bold text-white mb-4">Page Not Found</h2>
          <p className="text-gray-400 text-lg mb-8">
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-pink-500 text-white font-semibold rounded-lg hover:bg-pink-600 transition-colors"
          >
            <FiHome className="mr-2" size={20} />
            Go Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center px-6 py-3 border-2 border-gray-600 text-white font-semibold rounded-lg hover:border-pink-500 transition-colors"
          >
            <FiArrowLeft className="mr-2" size={20} />
            Go Back
          </button>
          <Link
            to="/collections"
            className="inline-flex items-center px-6 py-3 border-2 border-gray-600 text-white font-semibold rounded-lg hover:border-pink-500 transition-colors"
          >
            <FiSearch className="mr-2" size={20} />
            Browse Products
          </Link>
        </div>

        <div className="text-gray-500 text-sm">
          <p>If you believe this is an error, please contact our support team.</p>
        </div>
        </div>
      </div>
    </>
  );
}
